import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import bgImage from '../images/background.png';
import WineA from '../images/wine-a.png';
import WineB from '../images/wine-b.png';
import WineC from '../images/wine-c.png';
import WineD from '../images/wine-d.png';

const WINES = [
    { title: 'A', img: WineA },
    { title: 'B', img: WineB },
    { title: 'C', img: WineC },
    { title: 'D', img: WineD },
];

function CaIcon({ name, size = 20 }) {
    const p = { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' };
    switch (name) {
        case 'home':  return <svg {...p}><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>;
        case 'back':  return <svg {...p}><path d="M19 12H5M12 19l-7-7 7-7"/></svg>;
        case 'x':     return <svg {...p}><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
        case 'arrow': return <svg {...p}><path d="M5 12h14M12 5l7 7-7 7"/></svg>;
        default: return null;
    }
}

export default function ChooseAnswerAlert() {
    const { t } = useTranslation();
    const [testsData, setTestsData] = useState([]);
    const [answersData, setAnswersData] = useState([]);
    const [profileInfo, setProfileInfo] = useState({ id: 0 });
    const [alertVisible, setAlertVisible] = useState(true);
    const [ready, setReady] = useState(false);
    const navigate = useNavigate();

    useEffect(() => { requestAnimationFrame(() => setReady(true)); }, []);

    useEffect(() => {
        const storedUserInfo = localStorage.getItem('userLogged');
        if (storedUserInfo) {
            const userInfo = JSON.parse(storedUserInfo);
            setProfileInfo(userInfo);
        }
    }, []);

    useEffect(() => {
        if (profileInfo && profileInfo.id) {
            const xhr = new XMLHttpRequest();
            xhr.open("GET", `${process.env.REACT_APP_API_URL}/getAnswers/${profileInfo.id}`, true);
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    const data = JSON.parse(xhr.responseText);
                    setTestsData(data.tests);
                    setAnswersData(data.answers);
                }
            };
            xhr.send();
        }
    }, [profileInfo]);

    const handleWineClick = (e, wineTitle) => {
        const selectedTest = testsData.find(test => test.title === wineTitle);
        if (selectedTest) {
            const selectedAnswer = answersData.find(answer => Number(answer.test_id) === Number(selectedTest.id));
            if (selectedAnswer && selectedAnswer.object) {
                localStorage.setItem('currentTest', JSON.stringify(selectedTest));
                localStorage.setItem('currentAnswer', JSON.stringify(selectedAnswer.object));
            } else {
                e.preventDefault();
            }
        } else {
            e.preventDefault();
        }
    };

    const isWineDisabled = (wineTitle) => !testsData.some(test => test.title === wineTitle);

    return (
        <div className={`ca-stage${ready ? ' ca-ready' : ''}`}>
            <div className="ca-bg" style={{ backgroundImage: `url(${bgImage})` }} />
            <div className="ca-vignette" />
            <div className="ca-grain" />

            <div className="ca-topbar">
                <button className="ca-icon-btn" onClick={() => navigate('/')} aria-label={t('common.home')}>
                    <CaIcon name="home" size={16} />
                </button>
                <span className="ca-topbar-title">{t('test.correct_answers')}</span>
                <div style={{ width: 40 }} />
            </div>

            <div className="ca-panel">
                <h2 className="ca-heading">{t('choose_wine.title')}</h2>
                <div className="ca-bottles">
                    {WINES.map(({ title, img }, i) => (
                        <Link
                            key={title}
                            to="/answer"
                            className={`ca-bottle-link${isWineDisabled(title) ? ' ca-disabled' : ''}`}
                            onClick={(e) => handleWineClick(e, title)}
                            style={{ animationDelay: `${i * 60}ms` }}
                        >
                            <img src={img} alt={`${t('choose_wine.wine')} ${title}`} className="ca-bottle-img" width="80" height="150" />
                            <span className="ca-bottle-label">{title}</span>
                        </Link>
                    ))}
                </div>
            </div>

            <div className="ca-bottom">
                <button className="ca-bottom-btn" onClick={() => navigate(-1)}>
                    <CaIcon name="back" size={14} />{t('common.back')}
                </button>
            </div>

            {alertVisible && (
                <div className="ca-popup-overlay">
                    <div className="ca-popup">
                        <button className="ca-popup-close" onClick={() => setAlertVisible(false)} aria-label={t('common.close')}>
                            <CaIcon name="x" size={14} />
                        </button>
                        <p className="ca-popup-text">{t('test.no_active_game')}</p>
                        <button className="ca-popup-btn" onClick={() => navigate('/choose-answer')}>
                            {t('common.continue') || t('common.send')} <CaIcon name="arrow" size={13} />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
